export default {
  title: {
    regular: 'Almindelige modifikatorer til produkter',
    meal: 'Opret din menu-deal',
    upsell: 'Opret din mersalgsgruppe',
  },
  description: {
    regular:
      'Vælg modifikatorer, der skal indgå i den nye modifikatorgruppe, hvis de allerede findes i en anden modifikatorgruppe. Du kan også fortsætte med at oprette modifikatorgruppen og tilføje nye modifikatorer senere.',
    meal: 'Vælg de produkter, der skal indgå i din menu-deal. Hvis produkterne endnu ikke findes, skal du oprette dem på siden "Administrer menuer". Sørg for at knytte menu-dealen til de rigtige produkter i afsnittet "Modifikatorer" i produktbyggeren.',
    upsell:
      'Vælg de produkter, der skal indgå i din mersalgsgruppe. Hvis produkterne endnu ikke findes, skal du oprette dem på siden "Administrer menuer". Sørg for at knytte mersalgsgruppen til de rigtige produkter i afsnittet "Modifikatorer" i produktbyggeren.',
  },
  fields: {
    name: {
      label: 'Navn',
      placeholder: 'Indtast navn på modifikatorgruppe',
    },
    max_quantity: {
      label: 'Maks. antal',
      placeholder: 'Maks. antal modifikatorer',
    },
    is_required: {
      label: 'Påkrævet',
    },
  },
  labels: {
    visible: 'Synlig',
    hidden: 'Skjult',
    multiply: 'Kan multipliceres',
  },
  buttons: {
    save: 'Gem',
    close: 'Luk',
  },
  toasts: {
    modifier_group_got_created: 'Modifikatorgruppe oprettet',
    modifier_group_got_updated: 'Modifikatorgruppe opdateret',
  },
};
